/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Data_Delete_AllInputs */

const en_ui_data_delete_all = /** @type {(inputs: Ui_Data_Delete_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete all data`)
};

const de_ui_data_delete_all = /** @type {(inputs: Ui_Data_Delete_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Daten löschen`)
};

/**
* | output |
* | --- |
* | "Delete all data" |
*
* @param {Ui_Data_Delete_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_data_delete_all = /** @type {((inputs?: Ui_Data_Delete_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Data_Delete_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_data_delete_all(inputs)
	return de_ui_data_delete_all(inputs)
});